import React from 'react';
import map from 'lodash/map';

import { Button } from '@ps-design-system/components/Button';
import ArrowRightIcon from '@ps-design-system/icons/ArrowStylizedFilled/ArrowStylizedFilled16';
import { useResponsiveValue } from '../catering-landing-utils';

const desktopSteps = [
  <>Book a space in a<br />participating city</>,
  <>Follow the prompts to book<br />your catering</>,
  <>Eat, drink, and enjoy<br />your event</>
];

const mobileSteps = [
  <>Book a space in a<br />participating city</>,
  <>Follow the prompts to<br />book your catering</>,
  <>Eat, drink, and<br />enjoy your event</>
];

const desktopTitle = <>Book both your venue and<br/>catering through us</>;

const mobileTitle = <>Book both your<br/>venue and catering<br/>through us</>;

export const CateringLandingStepsSection = () => {
  const steps = useResponsiveValue(desktopSteps, mobileSteps);
  const title = useResponsiveValue(desktopTitle, mobileTitle);

  return (
    <div className="catering-landing-steps-section">
      <div className="ps-container-lg-margin ps-container-fixed relative catering-landing-steps-section-container">
        <div className="ps-row">
          <div className="col-xs-12 glass inner-container tw-rounded-8 flex space-between center middle column">
            <div className="steps-title text-white text-center heavier">{title}</div>
            <div className="steps-container">
              {map(steps, (step, index) => (
                <div className="step text-white text-center">
                  <div className="step-number h1">{index + 1}</div>
                  <div className="step-text">{step}</div>
                </div>
              ))}
            </div>
            <Button href="/" appearance="white" suffix={<ArrowRightIcon />} size="large">
              Get started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
